import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=23769936&scoped=true"
import script from "./video-list.vue?vue&type=script&lang=js"
export * from "./video-list.vue?vue&type=script&lang=js"
import style0 from "./video-list.vue?vue&type=style&index=0&id=23769936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23769936",
  null
  
)

export default component.exports